<template>
  <div class="pallet-page-stats">
    <div class="info-board">
      <div class="stats-info-card blue-business-bg">
        <div class="info-card-left">
          <span class="title">{{ counts[PalletUpcoming] }} Pallets</span>
          <span class="sub-title">{{ PalletUpcoming }}</span>
        </div>
      </div>
      <div class="stats-info-card blue-business-bg">
        <div class="info-card-left">
          <span class="title">{{ counts[PalletOnStack] }} Pallets</span>
          <span class="sub-title">{{ PalletOnStack }}</span>
        </div>
      </div>
      <div class="stats-info-card blue-business-bg">
        <div class="info-card-left">
          <span class="title">{{ counts[PalletOffStack] }} Pallets</span>
          <span class="sub-title">{{ PalletOffStack }}</span>
        </div>
      </div>
      <div class="stats-info-card blue-business-bg">
        <div class="info-card-left">
          <span class="title">{{ counts[PalletOnStage] }} Pallets</span>
          <span class="sub-title">{{ PalletOnStage }}</span>
        </div>
      </div>
      <div class="stats-info-card blue-business-bg">
        <div class="info-card-left">
          <span class="title">{{ counts[PalletShipping] }} Pallets</span>
          <span class="sub-title">{{ PalletShipping }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  PalletUpcoming,
  PalletOnStack,
  PalletOffStack,
  PalletOnStage,
  PalletShipping
} from '@/core/models/pallet'
import { queryPallets } from '@/api/pallet'
export default {
  name: 'PalletPageStats',
  data() {
    return {
      PalletUpcoming,
      PalletOnStack,
      PalletOffStack,
      PalletOnStage,
      PalletShipping,
      counts: {
        [PalletUpcoming]: 999,
        [PalletOnStack]: 999,
        [PalletOffStack]: 999,
        [PalletOnStage]: 999,
        [PalletShipping]: 999
      }
    }
  },
  mounted() {
    this.countPallets(PalletUpcoming)
    this.countPallets(PalletOnStack)
    this.countPallets(PalletOffStack)
    this.countPallets(PalletOnStage)
    this.countPallets(PalletShipping)
  },
  methods: {
    countPallets(status) {
      queryPallets({
        statusList: [status],
        size: 0
      }).then(res => {
        this.counts[status] = res.total
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.info-board {
  gap: 20px;
  flex-wrap: wrap;

  .stats-info-card {
    pointer-events: none;
    min-width: 160px !important;

    .info-card-left {
      .title {
        font-size: 30px;
        font-family: 'oswald bold', sans-serif;
      }

      .sub-title {
        margin-top: 5px;
        font-size: 24px;
        font-family: 'oswald light', sans-serif;
      }
    }
  }

  @extend .global-margin;
  @extend .f-r-vc;
}
</style>
